import React from 'react';
import { Typography , List, ListItem, ListItemText, Divider } from '@material-ui/core';

const Review = ({checkoutToken}) => {
  return (
    <>
    <Typography variant="h6" gutterBottom >
        Order Summary
    </Typography>
    <List disablePadding>
        {checkoutToken.live.line_items.map((product) => (
            <ListItem style={{paddding:'10px 0'}} key={product.name}> 
                <ListItemText primary={product.name} secondary={`Quantity: ${product.quantity }`}/>
                <Typography variant="body2">{product.line_total.formatted_with_symbol}</Typography>
            </ListItem>
        ))}
        <Divider variant="middle"/>
        <ListItem style={{paddding: '10px 0'}}>
            <ListItemText primary="Total" />
            <Typography variant="subtitle1" style={{fontWeight : 500}}>
                {checkoutToken.live.subtotal.formatted_with_symbol}
            </Typography> 
        </ListItem>
    </List>
    </>
  )
}

export default Review